import { useEffect, useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import SelectBox from "@/sharedComponents/molecules/SelectBox";
import CalendarIcon from "src/SharedComponents/atoms/CalendarIcon";
import styles from "./CrestAgileInput.module.css";
import { CrestAgileInputProps } from "./CrestAgileInput.types";
import SelectInputDropdownArrow from "../Icons/SelectInputDropdownArrow";
import ToolTip from "../ToolTip";

function CrestAgileInput(props: CrestAgileInputProps) {
  /* Variable definitions */

  const {
    variant = "primary",
    width = "normal",
    height = "medium",
    label,
    id,
    disabled,
    required = true,
    countryCode,
    placeholder,
    value,
    getInputedValue,
    selectOptions,
    isEmpty,
    errMsg,
    actionCallBack,
    readonly,
    traceChanges,
    textLimit,
    preSelection,
    showSearch,
    addToolTip,
    toolTipTitle,
    toolTipContent,
    // defaultDate = new Date().toISOString(),
    // defaultTime,
  } = props;
  const crestAgileInputClassName = classNames({
    [styles.crestAgileInput]: true,
    [styles.fullWidth]: width === "full",
    [styles.normalWidth]: width === "normal",
    [styles.middleWidth]: width === "middle",
    [styles.smallHeight]: height === "small",
    [styles.mediumHeight]: height === "medium",
    [styles.largeHeight]: height === "large",
    [styles.disabled]: disabled === true,
  });

  const [initialSelectOptions, setInitialSelectOptions] =
    useState(selectOptions);

  useEffect(() => {
    if (selectOptions !== undefined) {
      setInitialSelectOptions(selectOptions);
    }
  }, [selectOptions]);

  // const [chosenDate, setChosenDate] = useState(defaultDate);
  // const [chosenTime, setChosenTime] = useState(defaultTime);

  const [showSelectDropDown, setShowSelectDropDown] = useState<boolean>(false);
  // const [selectedOption, setSelectedOption] = useState<string>("");

  /* Function definitions */
  const toggleShowSelectDropDown = () => {
    setShowSelectDropDown(!showSelectDropDown);
  };

  const outerFrame = useRef<HTMLDivElement>(null);
  useOnClickOutside(outerFrame, () => {
    setShowSelectDropDown(false);
  });

  useEffect(() => {
    // if(defaultTime!==)
  });

  return (
    <div ref={outerFrame}>
      <div className="flex gap-1 text-sm text-white900">
        {label === " " ? <div className="h-6" /> : null}
        <div className=" text-neutral-800 font-medium text-base">{label}</div>
        <div className={required ? "text-red500" : "hidden"}>*</div>
        <div className={isEmpty ? "ml-2 text-sm text-red500" : "hidden"}>
          This field is required
        </div>
        <div
          // className={errMsg === "" ? "hidden" : "ml-2 text-sm text-red500"}
          className={"ml-2 text-sm text-red500"}
          id={
            id === "taskTitleInputField"
              ? "moduleTitleErrorValue"
              : id === "taskPositionInputField"
              ? "modulePositionErrorValue"
              : "titleErrorValue"
          }
        >
          {errMsg}
        </div>
      </div>
      <div className="w-full relative">
        {variant === "time" ? (
          <div
            className={`w-full pt-1 pb-1 px-4 ${
              height === "medium" ? "h-[33px]" : "h-11"
            } gap-x-1 border border-white400 flex outline-none text-base text-white700 rounded-md bg-white`}
          >
            <div className="self-center">
              <CalendarIcon />
            </div>

            <div className="self-center">
              <DatePicker
                required
                className="self-center  h-full w-full  outline-none bg-white text-black"
                selected={value}
                showTimeSelect
                showTimeSelectOnly
                dateFormat="h:mm aa"
                onSelect={() => {
                  if (actionCallBack) {
                    actionCallBack("time");
                  }
                }}
                onChange={(time: any) => {
                  if (getInputedValue) {
                    getInputedValue(time);
                  }
                  if (actionCallBack) {
                    actionCallBack("time");
                  }
                }}
                id="time-picker-compo"
              />
            </div>
          </div>
        ) : variant === "date" ? (
          <div
            className={`w-full pt-1 pb-1 px-4 ${
              height === "medium" ? "h-[33px]" : "h-11"
            } gap-x-1 border border-white400 flex outline-none text-base text-white700 rounded-md bg-white`}
          >
            <div className="self-center">
              <CalendarIcon />
            </div>
            <div className="self-center">
              <DatePicker
                required
                className="self-center w-full h-full  outline-none bg-white text-black"
                selected={value}
                dateFormat="dd/MM/yyyy"
                onSelect={() => {
                  if (actionCallBack) {
                    actionCallBack("date");
                  }
                }}
                onChange={(date: any) => {
                  if (getInputedValue) {
                    getInputedValue(date);
                  }
                  if (actionCallBack) {
                    actionCallBack(date);
                  }
                }}
                id="data-picker-compo"
              />
            </div>
          </div>
        ) : variant === "textarea" ? (
          <textarea
            required={required}
            className={styles.textArea}
            placeholder={placeholder}
            readOnly={readonly}
            value={value}
            id={id}
            onChange={(event) => {
              if (getInputedValue) {
                if (textLimit) {
                  if (event.target.value.length <= textLimit) {
                    getInputedValue(event.target.value);
                    if (actionCallBack) {
                      actionCallBack(event.target.value);
                    }
                  }
                } else {
                  getInputedValue(event.target.value);
                  if (actionCallBack) {
                    actionCallBack(event.target.value);
                  }
                }
              }
              if (traceChanges) {
                traceChanges();
              }
            }}
          />
        ) : variant === "text" ? (
          <input
            required={required}
            className={`${crestAgileInputClassName} input`}
            placeholder={placeholder}
            readOnly={readonly}
            type="text"
            value={value}
            id={id}
            onKeyUp={() => {
              localStorage.setItem(`taskfield${id}`, value);
              if (actionCallBack) {
                actionCallBack(value);
              }
            }}
            onChange={(event) => {
              if (getInputedValue) {
                if (textLimit) {
                  if (event.target.value.length <= textLimit) {
                    getInputedValue(event.target.value);
                    if (actionCallBack) {
                      actionCallBack(event.target.value);
                    }
                  }
                } else {
                  getInputedValue(event.target.value);
                  if (actionCallBack) {
                    actionCallBack(event.target.value);
                  }
                }
              }
              if (traceChanges) {
                traceChanges();
              }
            }}
          />
        ) : variant === "number" ? (
          <input
            required={required}
            className={crestAgileInputClassName}
            placeholder={placeholder}
            type="text"
            value={value === "undefined" ? "" : value}
            id={id}
            onKeyUp={() => {
              localStorage.setItem(`taskNumber${id}`, value);
            }}
            onChange={(event) => {
              if (getInputedValue) {
                const re = /^\d*\.?\d*$/;
                if (
                  event.target.value === "" ||
                  event.target.value === "undefined"
                ) {
                  getInputedValue("");
                  if (actionCallBack) {
                    actionCallBack(event.target.value);
                  }
                } else if (re.test(event.target.value)) {
                  if (
                    label?.includes("Pass Mark") &&
                    Number(event.target.value) > 100
                  ) {
                    getInputedValue(100);
                    if (actionCallBack) {
                      actionCallBack(100);
                    }
                  } else {
                    getInputedValue(Number(event.target.value));
                    if (actionCallBack) {
                      actionCallBack(event.target.value);
                    }
                  }

                  if (traceChanges) {
                    traceChanges();
                  }
                }
              }
            }}
          />
        ) : variant === "password" ? (
          <input
            className={crestAgileInputClassName}
            placeholder={placeholder}
            id={id}
            type="password"
            required={required}
            onKeyUp={() => {
              if (actionCallBack) {
                actionCallBack(value);
              }
            }}
            onChange={(event) => {
              if (getInputedValue) {
                getInputedValue(event.target.value);
              }
              if (actionCallBack) {
                actionCallBack(event.target.value);
              }
              if (traceChanges) {
                traceChanges();
              }
            }}
          />
        ) : variant === "email" ? (
          <input
            id={id}
            className={crestAgileInputClassName}
            placeholder={placeholder}
            type="email"
            value={value}
            required={required}
            disabled={disabled}
            onKeyUp={() => {
              if (actionCallBack) {
                actionCallBack(value);
              }
            }}
            onChange={(event) => {
              if (getInputedValue) {
                getInputedValue(event.target.value);
              }
              if (actionCallBack) {
                actionCallBack(event.target.value);
              }
              if (traceChanges) {
                traceChanges();
              }
            }}
          />
        ) : variant === "select" ? (
          <div className="relative">
            <div
              tabIndex={0}
              id={id}
              role="button"
              onKeyPress={() => {}}
              onClick={toggleShowSelectDropDown}
              className={
                crestAgileInputClassName +
                " flex justify-between cursor-pointer"
              }
            >
              <input
                className={styles.selectVariant}
                id={id}
                placeholder={placeholder}
                value={value === "" && value === undefined ? "" : value}
                required={required}
              />
              <div className="self-center cursor-pointer">
                <SelectInputDropdownArrow />
              </div>
            </div>
            {showSearch}
            <div
              id="dropdown_div"
              className={
                !showSelectDropDown
                  ? "hidden"
                  : "absolute w-full max-h-56 p-4 rounded-sm shadow text-base text-white700 bg-white overflow-y-scroll z-50"
              }
            >
              {showSearch && (
                <div className="w-full phone:w-[90%] h-[30px] rounded-md border border-[#EEE7F8]  flex">
                  <img
                    src="/icons/search.svg"
                    width={24}
                    height={24}
                    alt="search"
                    className="m-1.5"
                  />
                  <input
                    type="text"
                    id="searchInput"
                    placeholder="Search"
                    className="w-full  text-[#555555] px-2 h-full  outline-none "
                    onChange={({ target }) => {
                      if (selectOptions !== undefined) {
                        setInitialSelectOptions(
                          selectOptions.filter((items) =>
                            items
                              .toLowerCase()
                              .startsWith(target.value.toLowerCase())
                          )
                        );
                      }
                    }}
                  />
                </div>
              )}

              {selectOptions !== undefined ? (
                initialSelectOptions?.map((selectOption, index) => (
                  <div
                    id={`${id}dropdownValue${index}`}
                    className="w-full  p-1 cursor-pointer text-[#262626] hover:bg-white100"
                    tabIndex={0}
                    role="button"
                    // id={`selectOption-${index}`}
                    onKeyDown={() => {}}
                    onMouseLeave={() => {
                      if (actionCallBack) {
                        actionCallBack(value);
                      }
                    }}
                    onClick={() => {
                      // setSelectedOption(selectOption);
                      if (getInputedValue) {
                        getInputedValue(selectOption);
                      }

                      if (actionCallBack) {
                        actionCallBack(value);
                      }
                      toggleShowSelectDropDown();
                    }}
                  >
                    {selectOption}
                  </div>
                ))
              ) : (
                <div>No select values provided</div>
              )}
            </div>
          </div>
        ) : variant === "selectBox" ? (
          <div>
            <SelectBox
              id={id}
              selectOptions={selectOptions || []}
              getInputedValue={getInputedValue}
              activeSelectOption={preSelection}
              preSelection={preSelection}
            />
          </div>
        ) : variant === "phone" ? (
          <div className={crestAgileInputClassName + " flex"}>
            <div className="self-center w-16 text-black300">
              {countryCode} |
            </div>
            <input
              className="self-center w-full outline-none bg-white100"
              placeholder={placeholder}
              id={id}
              required={required}
              type="text"
              value={value === 0 ? "" : value}
              onChange={(event) => {
                if (getInputedValue) {
                  const re = /^\d*\.?\d*$/;
                  if (event.target.value === "") {
                    getInputedValue("");
                    if (actionCallBack) {
                      actionCallBack(event.target.value);
                    }
                  }
                  if (re.test(event.target.value)) {
                    getInputedValue(Number(event.target.value));
                    if (actionCallBack) {
                      actionCallBack(event.target.value);
                    }
                    if (traceChanges) {
                      traceChanges();
                    }
                  }
                }

                // if (getInputedValue) {
                //   getInputedValue(event.target.value);
                // }
                // if (traceChanges) {
                //   traceChanges();
                // }
              }}
            />
          </div>
        ) : variant === "submit" ? (
          <input
            className={crestAgileInputClassName + " cursor-pointer bg-black900"}
            type="submit"
            id={id}
            required={required}
            value="submit"
          />
        ) : (
          ""
        )}

        {addToolTip && (
          <div className="absolute right-3 top-[55%] -translate-y-1/2">
            <ToolTip
              content={
                <div className="w-full flex flex-col justify-center">
                  <p className="font-medium">{toolTipTitle}</p>
                  <p className="mt-1 text-gray-600 ">{toolTipContent}</p>
                </div>
              }
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default CrestAgileInput;
